import React, { useEffect, useState } from 'react'

import Button from '@react/react-spectrum/Button'
import Dialog from '@react/react-spectrum/Dialog'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import NumberInput from '@react/react-spectrum/NumberInput'
import { Table, TBody, TD, TH, THead, TR } from '@react/react-spectrum/Table'
import Textfield from '@react/react-spectrum/Textfield'

import Delete from '@react/react-spectrum/Icon/Delete'
import Edit from '@react/react-spectrum/Icon/Edit'

import './ShippingOptionEditor.scss'

const ShippingOptionEditor = ({ fields, disabled, onChange }) => {
  const [rows, setRows] = useState([])
  const hasEmptyRow = rows.length > 0 && rows.filter(r => !r.label).length > 0

  const saveField = (index, propName) => value => {
    const newRows = rows.map((r, idx) => (idx === index ? { ...r, [propName]: value } : r))
    setRows(newRows)
    onChange(newRows)
  }

  const addRow = () => {
    if (!hasEmptyRow) {
      const newRows = [...rows, {}]
      setRows(newRows)
    }
  }

  const deleteRow = index => {
    const newRows = rows.filter((r, idx) => idx !== index)
    setRows(newRows)
    onChange(newRows)
  }

  useEffect(() => {
    setRows(fields || [])
  }, [fields])

  return (
    <div className='shippingOptionEditor'>
      <Table onSubmit={evt => evt.preventDefault()}>
        <THead>
          <TH>Label</TH>
          <TH>Name</TH>
          <TH>Cost</TH>
          <TH></TH>
        </THead>
        <TBody>
          {rows.map((field, idx) => (
            <TR key={'field-' + idx}>
              <TD>
                <Textfield value={field.label} onChange={saveField(idx, 'label')} disabled={disabled} />
              </TD>
              <TD>
                <Textfield value={field.method} onChange={saveField(idx, 'method')} disabled={disabled} />
              </TD>
              <TD>
                <NumberInput value={field.cost} onChange={saveField(idx, 'cost')} disabled={disabled} />
              </TD>
              <TD>
                <Button
                  variant='tool'
                  aria-label='Delete'
                  icon={<Delete />}
                  onClick={() => deleteRow(idx)}
                  disabled={disabled}
                />
              </TD>
            </TR>
          ))}
          <TR onClick={addRow}>
            <TD>
              <Button variant='action' quiet label='+ Add' disabled={disabled || hasEmptyRow} />
            </TD>
            <TD />
            <TD />
            <TD />
          </TR>
        </TBody>
      </Table>
    </div>
  )
}

ShippingOptionEditor.defaultProps = {
  disabled: false,
}

const ShippingOptionEditorDialog = ({ label, fields, onChange, disabled, ...otherProps }) => {
  const [newContent, setNewContent] = useState(fields || [])
  return (
    <Dialog
      {...otherProps}
      className={'option-editor--dialog'}
      title={label || 'Option Editor'}
      confirmLabel='Save'
      cancelLabel='Discard'
      onConfirm={() => onChange(newContent)}
      role='dialog'
    >
      <ShippingOptionEditor fields={newContent} onChange={setNewContent} disabled={disabled} />
    </Dialog>
  )
}

const ShippingOptionEditorInput = ({ label, fields, disabled, onChange }) => (
  <ModalTrigger>
    <Button icon={<Edit />}>Open Editor</Button>
    <ShippingOptionEditorDialog label={label} fields={fields} onChange={onChange} disabled={disabled} />
  </ModalTrigger>
)

export { ShippingOptionEditor, ShippingOptionEditorDialog, ShippingOptionEditorInput }
